module.exports = __webpack_public_path__ + "img/1.278f4151.png";